module.exports = __webpack_public_path__ + "static/img/people.70caf93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/people.png
// module id = 4m07
// module chunks = 150